import React from "react"
import { ChangeEvent } from "react"
import { XIcon } from "lucide-react"
import { Input } from "~/ui/input"
import { Button } from "~/ui/button"
import searchIcon from "~/images/icons/search"

type SearchInputProps = {
  value: string
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
  placeholder: string
}

export const SearchInput = React.forwardRef<HTMLInputElement, SearchInputProps>(
  ({ value, onChange, placeholder }, ref) => {
    const clearInput = () => {
      onChange({ target: { value: "" } } as ChangeEvent<HTMLInputElement>)
    }

    return (
      <div className="relative w-72">
        <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
          <img {...searchIcon} alt="" className="h-5 w-5 text-gray-400" />
        </div>
        {value && value.length > 0 && (
          <div className="absolute right-0 top-0 flex h-full items-center pr-3">
            <Button
              variant="outline"
              className="h-5 w-5 rounded-full bg-white drop-shadow"
              size="icon"
              onClick={clearInput}
              onMouseDown={(e) => e.preventDefault()}
              tabIndex={-1}
            >
              <XIcon className="h-3 w-3" />
            </Button>
          </div>
        )}
        <Input
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className="text-xs-plus placeholder:text-gray-99 h-[44px] border-0 py-0 pl-10 pr-10 font-medium tracking-tight focus-visible:ring-0 focus-visible:ring-offset-0"
          ref={ref}
        />
      </div>
    )
  }
)

SearchInput.displayName = "SearchInput"
